import { render } from "./EnrollGameListView.vue?vue&type=template&id=1c6d0341"
import script from "./EnrollGameListView.vue?vue&type=script&lang=js"
export * from "./EnrollGameListView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__